import React, { useEffect } from 'react';
import { Button, Container, Row, Col, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom'
import styles from '../../Measures.module.scss';
import { data } from '../../../data';

const IQITechnical = () => {
    useEffect(() => {
        // Update the document title using the browser API
        document.title = `AHRQ QI: IQI Technical Specifications Updates - Version v2021, July 2021`;
      });
    return (<>

        <Container className='outerContainer'>
        <h1 className="centerText mb-5">Inpatient Quality Indicators Technical Specifications</h1>
        </Container>
        <Container className='outerContainer'>
        <h3 className="mb-5">Inpatient Quality Indicators Technical Specifications Updates - Version v2021, July 2021</h3>
            <Row>
                <Col md={8}>
                    <h4>Updated Inpatient Quality Indicators Technical Specifications (PDF Format), Version v2021 (Zip File)</h4>
                </Col>
                <Col md={4} className={styles.downloadSpecBtn}>
                    <Button href='https://www.qualityindicators.ahrq.gov/Downloads/Modules/IQI/V2021/TechSpecs/IQI_2021_ICD10_techspecs_pdf.zip'>Download All (.zip)</Button>
                </Col>
            </Row>
            <hr />
        </Container>

        <Container className='outerContainer'>
            <Table striped hover>
                <tbody >
                    {data.modules.filter((module) => module.topictag == "IQI-Indicators").map((information) => (<>
                        {information.indicators.map((info) => (<>
                            <tr>
                                <td><a href={info.current.url}>{info.current.name}</a></td>
                            </tr>
                        </>))}
                        {information.appendices.appendix.filter((a) => a.version == "V2021")[0].children.map((row) =>
                            <tr>
                                <td><a href={row.url}>{row.name}</a></td>
                            </tr>
                        )}

                    </>))}
                    <p className="danger mt-3">** To learn how to isolate the impact of COVID-19 on the AHRQ Quality Indicators (QIs), <a href="https://www.qualityindicators.ahrq.gov/Downloads/Resources/COVID19_UserNote_July2021.pdf">Click Here</a></p>
                </tbody>
            </Table>
        </Container>
        <Container className='outerContainer mt-5'>
            <h3>Retired Indicators</h3>
            <p><span className="danger">Effective v2021</span>, the following indicators have been retired. For additional information, refer to the retirement announcements: <a href="https://www.qualityindicators.ahrq.gov/News/AHRQ%20QI%20v2021%20Retirement%20Announcement.pdf">Indicators Retirement Announcement.</a></p>
            <ul>
                <li>IQI 32 Acute Myocardial Infarction (AMI) Mortality Rate, without Transfer Cases</li>
                <li>IQI 34 Vaginal Birth After Cesarean (VBAC) Rate</li>
            </ul>

            <p><span className="danger">Effective v2019</span>, the following indicators have been retired. For additional information, refer to the retirement announcements: <a href="https://www.qualityindicators.ahrq.gov/News/Retirement%20Notice_v2019_Indicators.pdf">Indicators Retirement Announcement.</a></p>
            <ul>
                <li>IQI 01 Esophageal Resection Volume</li>
                <li>IQI 02 Pancreatic Resection Volume</li>
                <li>IQI 04 Abdominal Aortic Aneurysm (AAA) Repair Volume</li>
                <li>IQI 05 Coronary Artery Bypass Graft (CABG)</li>
                <li>IQI 06 Percutaneous Coronary Intervention (PCI) Volume</li>
                <li>IQI 07 Carotid Endarterectomy Volume</li>
                <li>IQI 13 Craniotomy Mortality Rate</li>
                <li>IQI 14 Hip Replacement Mortality Rate</li>


            </ul>
            <p><span className="danger">Effective v7.0</span>, the following indicators have been retired. For additional information, refer to the retirement announcements: <a href="https://www.qualityindicators.ahrq.gov/News/IQI_Area_Level_Retirement_Notice.pdf">IQI Area Level Indicators</a> , <a href="https://www.qualityindicators.ahrq.gov/News/IQI_Hospital_Level_Retirement_Notice.pdf">IQI Hospital Level Indicators</a>.</p>
            <ul>
                <li>IQI 23 Laparoscopic Cholecystectomy Rate</li>
                <li>IQI 24 Incidental Appendectomy in the Elderly Rate</li>
                <li>IQI 25 Bilateral Cardiac Catheterization Rate</li>
                <li>IQI 26 Coronary Artery Bypass Graft (CABG) Rate</li>
                <li>IQI 27 Percutaneous Coronary Intervention (PCI) Rate</li>
                <li>IQI 28 Hysterectomy Rate</li>
                <li>IQI 29 Laminectomy or Spinal Fusion Rate</li>
            </ul>

        </Container>
        <Container className='outerContainer mt-5'>
            <div className='p-3 light-container'>
                <p className='mb-0'>Inpatient Quality Indicators Technical Specifications for SAS QI and WinQI ICD-10 v2020 can be found <Link to="../archive">here</Link> .</p>
            </div>
        </Container>

    </>)
}

export default IQITechnical;